// Notification sound using Web Audio API
let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext => {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  return audioContext;
};

export const playNotificationSound = async () => {
  try {
    const ctx = getAudioContext();
    
    // Resume context if suspended (browser autoplay policy)
    if (ctx.state === 'suspended') {
      await ctx.resume();
    }

    const now = ctx.currentTime;

    // Create oscillators for a pleasant chime
    const createTone = (frequency: number, startTime: number, duration: number, gain: number) => {
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(frequency, now);
      
      gainNode.gain.setValueAtTime(0, now + startTime);
      gainNode.gain.linearRampToValueAtTime(gain, now + startTime + 0.02);
      gainNode.gain.exponentialRampToValueAtTime(0.001, now + startTime + duration);
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.start(now + startTime);
      oscillator.stop(now + startTime + duration);
    };

    // Pleasant notification chime sequence
    createTone(880, 0, 0.15, 0.3);      // A5
    createTone(1108.73, 0.08, 0.15, 0.25); // C#6
    createTone(1318.51, 0.16, 0.25, 0.2);  // E6

  } catch (error) {
    console.log('Audio not available:', error);
  }
};

export const triggerHapticFeedback = () => {
  try {
    // Check if Vibration API is available
    if ('vibrate' in navigator) {
      // Short vibration pattern: vibrate 50ms, pause 30ms, vibrate 50ms
      navigator.vibrate([50, 30, 50]);
    }
  } catch (error) {
    console.log('Haptic feedback not available:', error);
  }
};

export const notifyNewEmail = async () => {
  await playNotificationSound();
  triggerHapticFeedback();
};
